import React from 'react';
import BotTemplate from '../components/TemplateBots/BotTemplate';
import AuthenticatedLayout from '../components/AuthenticatedLayout';

export default function BotTemplateConfig() {
    return (
        <AuthenticatedLayout title="Bot Templates">
            <BotTemplate />
        </AuthenticatedLayout>
    );
}
